<script context="module">
  export function callToggleSettings () {

    if(tglSettings !== null) tglSettings()
  }
  let tglSettings = null
</script>

<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
  } from '@sveltestrap/sveltestrap'
  import { clipboardData, errorState, errorMessage, username, basicAuth } from './services/stores.js'
  import { createEventDispatcher } from 'svelte';
  import { _ } from 'svelte-i18n'

  let open = false
  const size = 'lg'

  const dispatch = createEventDispatcher()

  const toggle = () => {
    open = !open
  }

  tglSettings = toggle
</script>

<Modal isOpen={open} {toggle} {size}>
    <ModalHeader {toggle}>{$_('settings.title')}</ModalHeader>
    <ModalBody>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua.
    </ModalBody>
    <ModalFooter>
      <Button color="primary" on:click={toggle}>Do Something</Button>
      <Button color="secondary" on:click={toggle}>Cancel</Button>
    </ModalFooter>
  </Modal>
